import ImageHelpers from '../GUI/ImageHelpers';

export class MainMenuScene extends Phaser.Scene {
  private mConfigs;
  private mButtons: Array<Phaser.GameObjects.Image> = [];
  private mBackground: Phaser.GameObjects.Image;

  constructor() {
    super({ key: "MainMenu" });
  }

  protected preload() {
    this.mConfigs = [
      {
        name: "practiceButton",
        path: "images/practiceButton.png",
        nextScene: "Practice",
      },
      {
        name: "storyButton",
        path: "images/storyButton.png",
        nextScene: "SelectArcScene",
      },
      {
        name: "shopButton",
        path: "images/shopButton.png",
        nextScene: "ShopScene",
      },
      {
        name: "charButton",
        path: "images/charButton.png",
        nextScene: "CharacterSkillScene",
      },
      {
        name: "settingsButton",
        path: "images/settingsButton.png",
        nextScene: "SettingsScene",
      },
    ];

    let scene = this;

    this.mConfigs.forEach((config) => {
      scene.load.image(config.name, config.path);
    });

    scene.load.image("mainBackground", "images/Scenes/MainMenu.png");
  }

  protected create() {
    const scene = this;

    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    this.mBackground = scene.add.image(width / 2, height / 2, "mainBackground");
    this.mBackground.setDisplaySize(width, height);

    // Middle of the screen (vertical center)
    const y = height / 2;

    // Gap scales with scene width (clamped so it won't get ridiculous)
    const gap = Phaser.Math.Clamp(width * 0.05, 20, 140);

    // 1) Create all buttons first (x will be set after we know widths)
    const buttons = this.mConfigs.map((config) => {
      const button = scene.add
        .image(0, y, config.name)
        .setInteractive()
        .on("pointerdown", () => {
          scene.cameras.main.fade(100);
          scene.time.delayedCall(100, () =>
            scene.scene.start(config.nextScene)
          );
        });

      ImageHelpers.SetHoverEffectOnImage(scene, button);

      scene.mButtons.push(button);
      return button;
    });

    // 2) Center the whole row based on actual button display widths
    const totalButtonsWidth = buttons.reduce(
      (sum, b) => sum + b.displayWidth,
      0
    );
    const totalRowWidth = totalButtonsWidth + gap * (buttons.length - 1);

    let cursorX = (width - totalRowWidth) / 2;

    buttons.forEach((b) => {
      b.x = cursorX + b.displayWidth / 2;
      b.y = y;
      cursorX += b.displayWidth + gap;
    });

    // Title (unchanged, but centered)
    const title = scene.add.text(0, 0, "Feathersteel Saga", {
      fontSize: "60px",
      color: "black",
      fontStyle: "bold",
    });
    title.setX(scene.scale.width / 2 - title.width / 2);
  }

  public update() {}
}